if (typeof ym !== undefined) {
  document.querySelectorAll('[data-getpdf]').forEach(link => {
    link.addEventListener('click', () => {
      const idCounter = Ya._metrika.getCounters()[0]?.id || null;

      if (idCounter && idCounter === 86479422) {
        ym(86479422,'reachGoal','price')
      }
    })
  });

  document.querySelectorAll('form').forEach(form => {
    form.addEventListener('submit', () => {
      if (Ya._metrika.getCounters().find(c => c.id === 97274634)) {
        ym(97274634,'reachGoal','form');
      }
    })
  });

  document.querySelector('[data-format-phone]')?.addEventListener('click', () => {
    if (Ya._metrika.getCounters().find(c => c.id === 97274634)) {
      ym(97274634,'reachGoal','clickphone');
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    if (Ya._metrika.getCounters().find(c => c.id === 97274634)) {
      setTimeout(() => {
        ym(97274634,'reachGoal','30sec');
      }, 30000)
    }
  });
}